module.exports = __webpack_public_path__ + "static/img/D.2ce7046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/D.png
// module id = U/Ts
// module chunks = 0